<section class="home-aliados" id="home-aliados" aria-labelledby="home-aliados-title">
  <div class="home-aliados__container">
    <div class="home-aliados__info">
      <div class="home-aliados__heading">
        <p class="home-aliados__eyebrow">{{ content.eyebrow }}</p>
        <h2 id="home-aliados-title" class="home-aliados__title" [innerHTML]="titleSafe"></h2>
      </div>

      <div class="home-aliados__copy">
        <p class="home-aliados__description">{{ content.description }}</p>

        <p class="home-aliados__join">
          {{ content.joinPrompt }}
          @if (content.uniteUrl) {
          <a class="home-aliados__join-link" [href]="content.uniteUrl" target="_blank" rel="noopener noreferrer">{{
            content.uniteLabel }}</a>
          } @else {
          <span class="home-aliados__join-link">{{ content.uniteLabel }}</span>
          }
        </p>
      </div>
    </div>

    @if (content.logos.length) {
    <div class="home-aliados__logos" aria-label="Aliados financieros">
      @if (rowA.length) {
      <div class="home-aliados__logos-row home-aliados__logos-row--top">
        <div class="home-aliados__logos-track home-aliados__logos-track--top">
          <div class="home-aliados__logos-set">
            @for (ally of rowA; track $index) {
            @if (ally.href) {
            <a class="home-aliados__logo-card" [href]="ally.href" target="_blank" rel="noopener noreferrer"
              [attr.aria-label]="ally.name">
              <img class="home-aliados__logo-img" [src]="ally.image" [alt]="ally.name" />
              <span class="home-aliados__logo-tint" aria-hidden="true"></span>
            </a>
            } @else {
            <span class="home-aliados__logo-card" [attr.aria-label]="ally.name">
              <img class="home-aliados__logo-img" [src]="ally.image" [alt]="ally.name" />
              <span class="home-aliados__logo-tint" aria-hidden="true"></span>
            </span>
            }
            }
          </div>
          <div class="home-aliados__logos-set" aria-hidden="true">
            @for (ally of rowA; track $index) {
            @if (ally.href) {
            <a class="home-aliados__logo-card" [href]="ally.href" target="_blank" rel="noopener noreferrer"
              tabindex="-1" [attr.aria-label]="ally.name">
              <img class="home-aliados__logo-img" [src]="ally.image" [alt]="" />
              <span class="home-aliados__logo-tint" aria-hidden="true"></span>
            </a>
            } @else {
            <span class="home-aliados__logo-card" [attr.aria-label]="ally.name">
              <img class="home-aliados__logo-img" [src]="ally.image" [alt]="" />
              <span class="home-aliados__logo-tint" aria-hidden="true"></span>
            </span>
            }
            }
          </div>
        </div>
      </div>
      }

      @if (rowB.length) {
      <div class="home-aliados__logos-row home-aliados__logos-row--bottom">
        <div class="home-aliados__logos-track home-aliados__logos-track--bottom">
          <div class="home-aliados__logos-set">
            @for (ally of rowB; track $index) {
            @if (ally.href) {
            <a class="home-aliados__logo-card" [href]="ally.href" target="_blank" rel="noopener noreferrer"
              [attr.aria-label]="ally.name">
              <img class="home-aliados__logo-img" [src]="ally.image" [alt]="ally.name" />
              <span class="home-aliados__logo-tint" aria-hidden="true"></span>
            </a>
            } @else {
            <span class="home-aliados__logo-card" [attr.aria-label]="ally.name">
              <img class="home-aliados__logo-img" [src]="ally.image" [alt]="ally.name" />
              <span class="home-aliados__logo-tint" aria-hidden="true"></span>
            </span>
            }
            }
          </div>
          <div class="home-aliados__logos-set" aria-hidden="true">
            @for (ally of rowB; track $index) {
            @if (ally.href) {
            <a class="home-aliados__logo-card" [href]="ally.href" target="_blank" rel="noopener noreferrer"
              tabindex="-1" [attr.aria-label]="ally.name">
              <img class="home-aliados__logo-img" [src]="ally.image" [alt]="" />
              <span class="home-aliados__logo-tint" aria-hidden="true"></span>
            </a>
            } @else {
            <span class="home-aliados__logo-card" [attr.aria-label]="ally.name">
              <img class="home-aliados__logo-img" [src]="ally.image" [alt]="" />
              <span class="home-aliados__logo-tint" aria-hidden="true"></span>
            </span>
            }
            }
          </div>
        </div>
      </div>
      }
    </div>
    }
  </div>
</section>